<template>
  <div class="md-layout text-center md-alignment-center-center" style="min-height: 100vh;">
    <div class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100">
      <login-card header-color="green">
        <img slot="logo" src="img/logo-black.png" style="border-radius: unset">
        <h4 slot="title" class="title"></h4>
        <div slot="description" class="description">
          <p>If you would like to sing up for Occtoo Partner Zone but you do not have an invite please contact us.</p>
          <a href="https://www.occtoo.com/contact-us">GO TO OCCTOO CONTACT PAGE</a>
        </div>
        <div slot="footer">
          <md-button class="md-simple md-warning md-lg" v-on:click="backToLogin">
            Back to login
          </md-button>
        </div>
      </login-card>
    </div>
  </div>
</template>
<script>

import {LoginCard} from '@/components'

export default {
  components: {
    LoginCard
  },
  data () {
    return {
    }
  },
  methods: {
    backToLogin() {
      this.$router.push('/login');
    }
  }
}
</script>

<style>
</style>
